import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  unLocodeService,
  type CreateUnLocodeRequest,
  type UpdateUnLocodeRequest,
} from '../../services/api/unLocodeService';

// --- UN/LOCODE Thunks ---

export const fetchUnLocodes = createAsyncThunk(
  'unLocode/fetchUnLocodes',
  async ({ searchText, status, pageNumber, pageSize, sortBy, sortDirection }: {
    searchText?: string; status?: string; pageNumber?: number; pageSize?: number; sortBy?: string; sortDirection?: string;
  }, { rejectWithValue }) => {
    try {
      return await unLocodeService.getUnLocodes(searchText, status, pageNumber, pageSize, sortBy, sortDirection);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch UN/LOCODEs');
    }
  }
);

export const fetchActiveUnLocodes = createAsyncThunk(
  'unLocode/fetchActiveUnLocodes',
  async (_, { rejectWithValue }) => {
    try {
      return await unLocodeService.getActiveUnLocodes();
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch active UN/LOCODEs');
    }
  }
);

export const createUnLocode = createAsyncThunk(
  'unLocode/createUnLocode',
  async (request: CreateUnLocodeRequest, { rejectWithValue }) => {
    try {
      return await unLocodeService.createUnLocode(request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to create UN/LOCODE');
    }
  }
);

export const updateUnLocode = createAsyncThunk(
  'unLocode/updateUnLocode',
  async ({ id, request }: { id: number; request: UpdateUnLocodeRequest }, { rejectWithValue }) => {
    try {
      return await unLocodeService.updateUnLocode(id, request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to update UN/LOCODE');
    }
  }
);

export const deleteUnLocode = createAsyncThunk(
  'unLocode/deleteUnLocode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await unLocodeService.deleteUnLocode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to delete UN/LOCODE');
    }
  }
);

export const activateUnLocode = createAsyncThunk(
  'unLocode/activateUnLocode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await unLocodeService.activateUnLocode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to activate UN/LOCODE');
    }
  }
);

export const deactivateUnLocode = createAsyncThunk(
  'unLocode/deactivateUnLocode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await unLocodeService.deactivateUnLocode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to deactivate UN/LOCODE');
    }
  }
);
